import type { Testimonial } from './services/testimonialsService'

export const SAMPLE_TESTIMONIALS: Testimonial[] = [
  {
    id: 'sample-1',
    author_name: 'Ana Ribeiro',
    author_handle: '@anar',
    avatar_url: 'https://api.dicebear.com/7.x/thumbs/svg?seed=Ana',
    text: 'O Cripto Alert reduziu meu ruído diário. Os alertas chegam com contexto e eu consigo agir rápido.',
    href: null,
    visible: true,
    position: 1,
  },
  {
    id: 'sample-2',
    author_name: 'Marcos Silva',
    author_handle: '@trader.marcos',
    avatar_url: 'https://api.dicebear.com/7.x/thumbs/svg?seed=Marcos',
    text: 'Passei a filtrar operações com base nas confluências e no mandante. Minha disciplina agradece.',
    href: null,
    visible: true,
    position: 2,
  },
  {
    id: 'sample-3',
    author_name: 'Beatriz Lima',
    author_handle: '@bealima',
    avatar_url: 'https://api.dicebear.com/7.x/thumbs/svg?seed=Beatriz',
    text: 'Os sinais são auditáveis e a governança é clara. Muito acima do que já usei.',
    href: null,
    visible: true,
    position: 3,
  },
]

